import React from 'react';

import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

export interface FeatureResultProps {
  end: number;
  name: Array<string>;
  start: number;
  strand: string;
}

function FeatureResult({end, name, start, strand}: FeatureResultProps): JSX.Element {
  return (
    <li className="feature-result">
      <a href="#">
        <div className="feat-swatch pull-left">{strand}</div>
        <div className="text">
          <span className="location pull-right">
            <span className="start">{start}</span>
            <span>-</span>
            <span className="end">{end}</span>
          </span>
          <div className="name">
            <span>{name[0]}</span>
            <span className="match">{name[1]}</span>
            <span>{name[2]}</span>
          </div>
        </div>
      </a>
    </li>
  );
}

export default makeDeprecatedJadeStyleTemplate<FeatureResultProps>(FeatureResult);
